import axios from "axios";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/quote";
import { Action as AuthAction } from "api/action_types/authentication";
import { ActionType } from "api/action_types/quote";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { ColorOption } from "api/types/quote";
import { url_prefix } from "settings";
import { color_option_url } from "../endpoint";

export const updateColorOption = (color_option: ColorOption, id?: number) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.QUOTE_UPDATING
    });

    dispatch({
      type: ActionType.UPDATE_LOCAL_COLOR_OPTION,
      payload: color_option
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${color_option_url}/${id ? id : 0}/?uuid=${color_option.uuid}&`;

    try {
      const { data } = await axios.patch(url, color_option, config);

      dispatch({
        type: ActionType.QUOTE_ACTION_SUCCESS,
        payload: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.QUOTE_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
